import { render, staticRenderFns } from "./BDTIcon.vue?vue&type=template&id=1b77fc80&"
import script from "./BDTIcon.vue?vue&type=script&lang=js&"
export * from "./BDTIcon.vue?vue&type=script&lang=js&"
import style0 from "./BDTIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports